module.exports = __webpack_public_path__ + "static/media/humidity.7f56e8e0.svg";